import React from 'react';
import { getRegion } from 'utils/Region';
import './SeleccionCard.scss';
import { pushEvent } from 'containers/Player/utils/analytics';
import {
  events,
  Actions,
  category,
} from 'containers/MundialViews/utils/analytics';
import { useNavigate } from 'react-router-dom';

const SeleccionCard = ({ imgSeleccion, nameSeleccion, id }) => {
  const navigate = useNavigate();
  const handlePlayerClick = id => {
    pushEvent(
      events.CARRUSELES,
      category.CARRUSELES,
      Actions.NATIONAL,
      nameSeleccion?.toLowerCase(),
    );
    window.scrollTo(0, 0);
    return navigte(`/${getRegion()}/vcard/team/${id}`);
  };
  return (
    <div
      style={{ marginRight: '24px', width: '104px', height: '104px' }}
      className="cardSeleccion"
      onClick={() => handlePlayerClick(id)}
    >
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <div
          style={{
            width: '104px',
            height: '104px',
            borderRadius: '60px',
            background: '#242946',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <img
            src={
              imgSeleccion.placeholder ? imgSeleccion.placeholder : imgSeleccion
            }
            className={
              imgSeleccion.placeholder ? 'placeholdeRibbon' : 'seleccionesSize'
            }
          />
        </div>
      </div>

      <div style={{ marginTop: '8px' }}>
        <p
          style={{
            textAlign: 'center',
            fontFamily: 'Roboto',
            fontSize: '14px',
          }}
        >
          {nameSeleccion}
        </p>
      </div>
    </div>
  );
};

export default SeleccionCard;
